var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "go-modal",
    {
      attrs: { "dialog-class": "go-modal-prompt" },
      on: { "modal:close": _vm.close },
      scopedSlots: _vm._u([
        {
          key: "modal-header",
          fn: function () {
            return [
              _c("div", { staticClass: "go-text-wrap" }, [
                _c("div", { staticClass: "modal-title" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(
                        _vm.$t("briefing.popup.go-over-again.header.title")
                      ) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "go-help-text",
                    staticStyle: { color: "#fd7e15" },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t(
                            "briefing.popup.go-over-again.header.description"
                          )
                        ) +
                        "\n      "
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-icon close",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      return _vm.close.apply(null, arguments)
                    },
                  },
                },
                [_c("i", { staticClass: "go-icon-24 go-icon-close" })]
              ),
            ]
          },
          proxy: true,
        },
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "button",
                {
                  staticClass: "btn go-btn-default go-btn-lg",
                  attrs: { type: "button" },
                  on: { click: _vm.close },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("global.buttons.cancel")) +
                      "\n    "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn go-btn-primary go-btn-lg",
                  attrs: { type: "button" },
                  on: { click: _vm.save },
                },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("global.buttons.save")) +
                      "\n    "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
      ]),
      model: {
        value: _vm.open,
        callback: function ($$v) {
          _vm.open = $$v
        },
        expression: "open",
      },
    },
    [
      _vm._v(" "),
      _c("div", { staticClass: "go-panel go-panel-createSet" }, [
        _c("div", { staticClass: "go-panel-header" }, [
          _c("div", { staticClass: "go-text-wrap" }, [
            _c("div", { staticClass: "go-panel-title" }, [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "briefing.popup.createBriefing.reportTypeSelect.top.title.REPORT"
                  )
                )
              ),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "go-panel-body" }, [
          _c("div", { staticClass: "go-createSet-list" }, [
            _c("div", { staticClass: "go-list-item go-form-group" }, [
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-checkbox custom-control-inline",
                },
                [
                  _c("input", {
                    staticClass: "custom-control-input",
                    attrs: { type: "checkbox", id: "customCheck1" },
                    domProps: {
                      checked:
                        _vm.formData.reportType === _vm.REPORT_TYPES.DAILY,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectType(_vm.REPORT_TYPES.DAILY)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "customCheck1" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.optionName.dailyReport"
                            )
                          ) +
                          "\n              "
                      ),
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.smallText.dailyReport"
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.reportStyle["DAILY"],
                      expression: "formData.reportStyle['DAILY']",
                    },
                  ],
                  staticClass: "go-form-control",
                  class: {
                    "input-disable":
                      _vm.formData.reportType !== _vm.REPORT_TYPES.DAILY,
                  },
                  attrs: {
                    disabled:
                      _vm.formData.reportType !== _vm.REPORT_TYPES.DAILY,
                  },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.formData.reportStyle,
                        "DAILY",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c(
                    "option",
                    { domProps: { value: _vm.REPORT_STYLES.BUSINESS } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.business"
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    { domProps: { value: _vm.REPORT_STYLES.BLOG } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.blog"
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-list-item go-form-group" }, [
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-checkbox custom-control-inline",
                },
                [
                  _c("input", {
                    staticClass: "custom-control-input",
                    attrs: { type: "checkbox", id: "customCheck2" },
                    domProps: {
                      checked:
                        _vm.formData.reportType ===
                        _vm.REPORT_TYPES.PRODUCT_REVIEW,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectType(_vm.REPORT_TYPES.PRODUCT_REVIEW)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "customCheck2" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.optionName.productReviewReport"
                            )
                          ) +
                          "\n              "
                      ),
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.smallText.productReviewReport"
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.reportStyle["PRODUCT_REVIEW"],
                      expression: "formData.reportStyle['PRODUCT_REVIEW']",
                    },
                  ],
                  staticClass: "go-form-control",
                  class: {
                    "input-disable":
                      _vm.formData.reportType !==
                      _vm.REPORT_TYPES.PRODUCT_REVIEW,
                  },
                  attrs: {
                    disabled:
                      _vm.formData.reportType !==
                      _vm.REPORT_TYPES.PRODUCT_REVIEW,
                  },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.formData.reportStyle,
                        "PRODUCT_REVIEW",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c(
                    "option",
                    { domProps: { value: _vm.REPORT_STYLES.BUSINESS } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.business"
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    { domProps: { value: _vm.REPORT_STYLES.BLOG } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.blog"
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-list-item go-form-group" }, [
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-checkbox custom-control-inline",
                },
                [
                  _c("input", {
                    staticClass: "custom-control-input",
                    attrs: { type: "checkbox", id: "customCheck3" },
                    domProps: {
                      checked:
                        _vm.formData.reportType === _vm.REPORT_TYPES.INVESTMENT,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectType(_vm.REPORT_TYPES.INVESTMENT)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "customCheck3" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.optionName.investmentReport"
                            )
                          ) +
                          "\n              "
                      ),
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.smallText.investmentReport"
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.reportStyle["INVESTMENT"],
                      expression: "formData.reportStyle['INVESTMENT']",
                    },
                  ],
                  staticClass: "go-form-control",
                  class: {
                    "input-disable":
                      _vm.formData.reportType !== _vm.REPORT_TYPES.INVESTMENT,
                  },
                  attrs: {
                    disabled:
                      _vm.formData.reportType !== _vm.REPORT_TYPES.INVESTMENT,
                  },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.formData.reportStyle,
                        "INVESTMENT",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c(
                    "option",
                    { domProps: { value: _vm.REPORT_STYLES.BUSINESS } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.business"
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "option",
                    { domProps: { value: _vm.REPORT_STYLES.BLOG } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.blog"
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "go-list-item go-form-group" }, [
              _c(
                "div",
                {
                  staticClass:
                    "custom-control custom-checkbox custom-control-inline",
                },
                [
                  _c("input", {
                    staticClass: "custom-control-input",
                    attrs: { type: "checkbox", id: "customCheck5" },
                    domProps: {
                      checked:
                        _vm.formData.reportType ===
                        _vm.REPORT_TYPES.INDEPTH_DAILY,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.selectType(_vm.REPORT_TYPES.INDEPTH_DAILY)
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "label",
                    {
                      staticClass: "custom-control-label",
                      attrs: { for: "customCheck5" },
                    },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.optionName.inDepthReport"
                            )
                          ) +
                          "\n              "
                      ),
                      _c("small", [
                        _vm._v(
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.smallText.inDepthReport"
                            )
                          )
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.formData.reportStyle["INDEPTH_DAILY"],
                      expression: "formData.reportStyle['INDEPTH_DAILY']",
                    },
                  ],
                  staticClass: "go-form-control go-select-one-child",
                  class: {
                    "input-disable":
                      _vm.formData.reportType !==
                      _vm.REPORT_TYPES.INDEPTH_DAILY,
                  },
                  attrs: {
                    disabled:
                      _vm.formData.reportType !==
                      _vm.REPORT_TYPES.INDEPTH_DAILY,
                  },
                  on: {
                    change: function ($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function (o) {
                          return o.selected
                        })
                        .map(function (o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.$set(
                        _vm.formData.reportStyle,
                        "INDEPTH_DAILY",
                        $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      )
                    },
                  },
                },
                [
                  _c(
                    "option",
                    { domProps: { value: _vm.REPORT_STYLES.BUSINESS } },
                    [
                      _vm._v(
                        "\n              " +
                          _vm._s(
                            _vm.$t(
                              "briefing.popup.createBriefing.reportTypeSelect.optionSelectReport.business"
                            )
                          ) +
                          "\n            "
                      ),
                    ]
                  ),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "go-panel go-info-box" }, [
        _c("ul", { staticClass: "go-info-list" }, [
          _c("li", { staticClass: "go-list-item" }, [
            _vm._v(
              _vm._s(_vm.$t("briefing.popup.reportSetting.guidance.firstText"))
            ),
          ]),
          _vm._v(" "),
          _c("li", { staticClass: "go-list-item" }, [
            _vm._v(
              _vm._s(_vm.$t("briefing.popup.reportSetting.guidance.secondText"))
            ),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }